module.exports = __webpack_public_path__ + "static/media/sb.e36f0602.webp";